// axios
import axios from 'axios';


const baseURL = process.env.VUE_APP_DIGOF_URL

const digofHttp = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token'))
  }
  // You can add your headers here
})

const laperonURL = process.env.VUE_APP_LAPERON_URL;
const laperonHttp = axios.create({
  baseURL: laperonURL,

})

export {
  digofHttp,
  laperonHttp
};
